import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { loginUser } from '../../utils/api';

import '../../assets/css/login.css';

const Login = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { email, password };

        try {
            const response = await loginUser(data);
            login(response.user, response.token);
            navigate('/');
            window.location.reload();
        } catch (err) {
            setError('Invalid email or password');
        }
    };

    return (
        <div className='login-form'>
            <form onSubmit={handleSubmit}>
                <div className='input-group'>
                    <label for='email'>E-Mail</label>
                    <input
                        id='email'
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autocomplete="email"
                    />
                </div>
                <div className='input-group'>
                    <label for='password'>Passwort</label>
                    <input
                        id='password'
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autocomplete="current-password"
                    />
                </div>
                <button type="submit">Login</button>

                <div className='headline'>
                    Neu bei NGCTV?
                </div>
                <div className='subline'>
                    Registriere dich jetzt kostenlos
                </div>
                <Link to="/register" className="btn-register" viewTransition>Jetzt kostenlos registrieren</Link>
            </form>
            {error && <div>{error}</div>}
        </div>
    );
};

export default Login;
